import { render, staticRenderFns } from "./DonationReceipt.vue?vue&type=template&id=66120152&"
import script from "./DonationReceipt.vue?vue&type=script&lang=js&"
export * from "./DonationReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66120152')) {
      api.createRecord('66120152', component.options)
    } else {
      api.reload('66120152', component.options)
    }
    module.hot.accept("./DonationReceipt.vue?vue&type=template&id=66120152&", function () {
      api.rerender('66120152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DonationModal/DonationReceipt.vue"
export default component.exports